import type { SVGProps } from "react";
// generated from ZoomIn.svg — do not edit manually
// prettier-ignore
export default function ZoomIn(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
  <circle cx="10.5" cy="10.5" r="7" stroke="currentColor" strokeWidth="1.5"/>
  <path d="M15.5 15.5L21 21" stroke="currentColor" strokeWidth="1.5"/>
  <path d="M7.5 10.5H13.5" stroke="currentColor" strokeWidth="1.5"/>
  <path d="M10.5 7.5V13.5" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
